module.exports = __webpack_public_path__ + "img/drizzle.c6679dc6.jpg";